<mat-dialog-content>

    <mat-card-title>
        <h4>Selecione uma fazenda</h4>
    </mat-card-title>

    <mat-card class="mb-3 custom-card">

        <mat-card-content
            [style.height.px]="'80'"
            [style.width.px]="'600'"
            class="col-12 col-sm-12">

            <div mat-dialog-actions class="row justify-content-center">

                <form class="form">

                    <mat-form-field class="col-12 col-sm-12" appearance="outline">

                        <mat-label>Selecione a fazenda</mat-label>

                        <input
                            type="text"
                            placeholder="Selecione a fazenda"
                            aria-label="Number"
                            matInput
                            [formControl]="myControl"
                            [matAutocomplete]="auto">

                        <mat-autocomplete
                            #auto="matAutocomplete"
                            (optionSelected)='onSelectFarmChange($event.option.value)'
                            [displayWith]="displayFn">
                            <mat-option
                                *ngFor="let fazenda of listaFazendasFiltrada | async"
                                [value]="fazenda">
                                    {{ fazenda.nome }} ({{ fazenda.proprietario }})
                            </mat-option>
                        </mat-autocomplete>

                    </mat-form-field>

                </form>

            </div>

        </mat-card-content>

    </mat-card>

</mat-dialog-content>

<div class="row p-2 mr-3 ml-3">

    <div class="col-sm-4 col-12 p-1 justify-content-start">

        <button
            mat-mdc-raised-button
            [mat-dialog-close]="fazendaSelecionada"
            class="btn btn-submit w-100 custom-button-flex"
            matTooltip="Selecionar fazenda"
            (click)="onSelectFarm()">
            <div class="d-flex align-items-center justify-content-center">
                <mat-icon>done_outline</mat-icon>
                <span class="pl-2">Selecionar</span>
            </div>
        </button>

    </div>

    <div class="col-sm-4 col-12 p-1 justify-content-end">

        <button
            *ngIf="isAdmin || isAdminTecnico"
            mat-mdc-raised-button
            [mat-dialog-close]="nenhumaFazendaSelecionada"
            class="btn btn-submit w-100 custom-button-flex"
            (click)="onSelectNoFarm()"
            matTooltip="Não utilizar nenhuma fazenda">
            <div class="d-flex align-items-center justify-content-center">
                <mat-icon>done_outline</mat-icon>
                <span class="pl-2">Nenhuma</span>
            </div>
        </button>

    </div>

    <div class="col-sm-4 col-12 p-1 justify-content-end">

        <button
            mat-mdc-raised-button
            [mat-dialog-close]="closed"
            class="btn btn-cancel w-100 custom-button-flex"
            matTooltip="Fechar">
            <div class="d-flex align-items-center justify-content-center">
                <mat-icon>close</mat-icon>
                <span class="pl-2">Fechar</span>
            </div>
        </button>

    </div>

</div>
